import { useQuery } from "@tanstack/react-query";
import { CompanyApiClient } from "@/features/company/api-client/api-client";
import { useCompanyContext } from "@/features/company/hooks/use-company-context";
import { QueryOptionsFactory } from "@/features/company/utils";
import { LinkSchemas } from "@/types/legal-entity/links.type";

export const useLinks = () => {
  const { leUuid: legalEntityUuid } = useCompanyContext();

  // GET all alias mobile from real //
  const useGetLinksFromLegalEntity = () =>
    useQuery<LinkSchemas[]>({
      ...QueryOptionsFactory.links(legalEntityUuid),
      enabled: !!legalEntityUuid,
      queryFn: async () => await CompanyApiClient.getAllLinks(legalEntityUuid ?? ""),
      staleTime: 10 * 60 * 1000,
      retry: false,
      throwOnError: true
    });

  return { useGetLinksFromLegalEntity };
};
